import React, { useState } from 'react';
import { GOLD, BLACK } from '../constants/theme';
import { IMGS } from '../constants/images';
import SecLabel from './ui/SecLabel';

const Gallery: React.FC = () => {
  const [lb, setLb] = useState<string | null>(null);
  return (
    <section id="gallery" style={{ background:BLACK, padding:'90px 8vw' }}>
      <SecLabel text="OUR GALLERY"/>
      <h2 style={{ fontFamily:'Cormorant Garamond', fontSize:'clamp(28px,3.6vw,48px)', fontWeight:300, color:'#fff', textAlign:'center', marginTop:6 }}>
        A Feast for <em style={{ color:GOLD }}>the Eyes</em>
      </h2>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gridTemplateRows:'repeat(2,190px)', gap:3, marginTop:44 }}>
        {IMGS.gallery.map((src,i) => (
          <div key={i} style={{ overflow:'hidden', cursor:'pointer', gridColumn:i===0?'span 2':'span 1', gridRow:i===0?'span 2':'span 1' }} onClick={() => setLb(src)}>
            <img src={src} alt={`Gallery ${i+1}`} style={{ width:'100%', height:'100%', objectFit:'cover', filter:'brightness(0.8)', transition:'transform 0.5s, filter 0.4s' }}
              onMouseOver={e => { (e.currentTarget as HTMLElement).style.transform='scale(1.08)'; (e.currentTarget as HTMLElement).style.filter='brightness(1.05)'; }}
              onMouseOut={e => { (e.currentTarget as HTMLElement).style.transform='scale(1)'; (e.currentTarget as HTMLElement).style.filter='brightness(0.8)'; }}/>
          </div>
        ))}
      </div>
      {lb && (
        <div onClick={() => setLb(null)} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.94)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center' }}>
          <img src={lb} alt="Preview" style={{ maxWidth:'90vw', maxHeight:'90vh', border:`2px solid ${GOLD}` }}/>
          <button onClick={() => setLb(null)} style={{ position:'absolute', top:22, right:22, background:'none', border:'none', color:GOLD, fontSize:30, cursor:'pointer' }}>✕</button>
        </div>
      )}
    </section>
  );
};

export default Gallery;